<script>
const COLORS = [
  "#0074D9",
  "#7FDBFF",
  "#39CCCC",
  "#3D9970",
  "#2ECC40",
  "#01FF70",
  "#FFDC00",
  "#FF851B",
  "#FF4136",
  "#85144b",
  "#F012BE",
  "#B10DC9",
  "#001f3f",
]

export default {
  name: "StandOptionsMixin",
  methods: {
    getStandOptions(index) {
      const colorIndex = index % COLORS.length
      const color = COLORS[colorIndex]
      return {
        color: color,
        fillColor: color,
        fillOpacity: 0.5,
      }
    },
  },
}
</script>
